<template>
	<v-container>
		<v-row justify="center">
			<v-col cols="12" sm="8" class="text-left">
				<template v-if="person && person.publications.length">
					<div class="" v-for="(pub, index) in person.publications" :key="index">
						<v-card class=" ma-2 pa-2" tile v-if="checkPdf(pub.url)">
							<v-img class="" height="100px">
								<pdf :src="pub.url" style="height: 100px; "></pdf>
							</v-img>
							<v-card-title class="text-uppercase">{{ pub.name }}</v-card-title>

							<v-btn
								:color="pub.seen ? 'success' : 'accent'"
								small
								class="ma-2"
								:to="`/guest/render-pdf?publicationId=${pub._id}`"
								target="_blank"
							>
								<v-icon small>
									mdi-eye-settings
								</v-icon>
								<span> {{ pub.seen ? 'Volver a ver' : 'Revisar' }}</span>
							</v-btn>
							<span v-if="pub.seen" class="caption">
								<v-icon small>
									mdi-check
								</v-icon>
								Visto {{ formatSeen(pub) }}
							</span>
							<span v-else>Aún sin ver</span>
						</v-card>
						<v-card class=" ma-2 pa-2" tile v-else>
							<v-card-title class="text-uppercase"
								>{{ pub.name }} (Video mp4)</v-card-title
							>

							<v-btn
								:color="pub.seen ? 'success' : 'accent'"
								small
								class="ma-2"
								:to="`/guest/render-video?publicationId=${pub._id}`"
								target="_blank"
							>
								<v-icon small>
									mdi-eye-settings
								</v-icon>
								<span> {{ pub.seen ? 'Volver a ver' : 'Revisar' }}</span>
							</v-btn>
							<span v-if="pub.seen" class="caption">
								<v-icon small>
									mdi-check
								</v-icon>
								Visto {{ formatSeen(pub) }}
							</span>
							<span v-else>Aún sin ver</span>
						</v-card>
					</div>
				</template>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import pdf from 'vue-pdf';
import moment from 'moment';

export default {
	components: {
		pdf,
	},
	data() {
		return {
			position: 0,
		};
	},
	computed: {
		...mapGetters({
			person: 'Person/person',
		}),
	},
	methods: {
		checkPdf(url) {
			return url.includes('pdf');
		},
		formatPublicationDate(publication) {
			return moment(publication.updatedAt).fromNow();
		},
		formatSeen(publication) {
			if (publication) return this.formatPublicationDate(publication);
			return 'Aún sin leer';
		},
	},
};
</script>
